import Firebase from "firebase";
import { Cache } from "aws-amplify";
import { post } from "./Axios";
import logger from "./Logging"

// Key to be used for storing the token in cache
const TOKEN_STORAGE_KEY = "_firebasetoken";

const firebaseConfig = {
  apiKey: "AIzaSyB9FIQI1QhfRH825lLQslDioKlC0xPHGa4",
  authDomain: "ilivestock.firebaseapp.com",
  databaseURL:
    process.env.REACT_APP_STAGE === "production"
      ? "https://ilivestock.firebaseio.com"
      : "https://ilivestock-develop.firebaseio.com/",
  projectId: "ilivestock",
  storageBucket: "ilivestock.appspot.com",
  messagingSenderId: "131978604472",
  appId: "1:131978604472:web:c3985aa72ae9575169e94d",
  measurementId: "G-NQTRCM42MJ",
};

Firebase.initializeApp(firebaseConfig);

export const database = Firebase.database();

const authorize = async () => {
  try {
    if (Firebase.auth().currentUser) return;
    const { data } = await post<{ token: string }>({ path: "/firebase/token" });
    await Firebase.auth().signInWithCustomToken(data.token);
  } catch (error) {
    logger.log(
      "error",
      "Firebase authorize",
      {
        additionalInfo: {
          tags: "firebase",
          body: error,
          file: "config.Firebase",
          user: null,
        }
      }
    )

    throw error;
  }
};

export const ref = async (
  path?: string
): Promise<Firebase.database.Reference> => {
  try {
    let fullPath = "/businesses";
    if (path) fullPath += path;
    await authorize();
    return Firebase.database().ref(fullPath);
  } catch (error) {
    logger.log(
      "error",
      "Firebase businesses",
      {
        additionalInfo: {
          tags: "firebase",
          body: error,
          file: "config.Firebase",
          user: null,
        }
      }
    )

    throw error;
  }
};
